import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import _ from "lodash"

import Loading from "../../../common/Loading"
import CommonApprovalDisplay from "../../../common/CommonApprovalDisplay"

import { insertApprovalInstances } from "../../../services/api/approvalInstances"

import { raiseToast } from "../../../services/redux/reducers/toast/toast"

import { getApprovalParams, getApproverDetails, getPaymentTermsString, numberConversion, round } from "../../../utils"
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig"
import moment from "moment"


const NewApprovalDisplay = (props) => {
    const { 
        sellerPO, 
        sellerReq,
        approvalTypes,
        approvalInstances, 
        isDoc, 
        approvalRequestStatusDetails,
        setApprovalRequestStatusDetails, 
        sellerPOApprovals,
        approvalSecondary,
        handleApprovalRequest,
        sellerCompanyDetails,
        companyCreditPeriods,
        handleRemarks,
        buyerQuoteItems,
        sellerPOItems,
        materialDetails,
        tdsSections,
        buyerPOItems,
        materialMandatoryUseFromStock,
        materialBrands,
        companyCertificates
    } = props 

    const [raiseReqLoading, setRaiseReqLoading] = useState(false)

    const dispatch = useDispatch()
    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(sellerPO.pmCompanyId)
    let currencyShortName = pmCompanyConfig.currencyShortName

    const handleRaiseReq = async (displayApproval) => {
        if(!displayApproval.remarks){
            return dispatch(raiseToast({severity:'error', detail: "Please enter remarks!", life: 3000}))
        }

        const relatedApproval = sellerPOApprovals.find(eachApproval => eachApproval.approvalId === displayApproval.approvalId)
        if (relatedApproval.config?.isUploadFileMandatory){
            if(!displayApproval.uploadFile?.length){
                return dispatch(raiseToast({severity:'error', detail: "Please Upload document!", life: 3000}))
            }
            else if(sellerPO.expenseCategoryId === 16 && displayApproval.uploadFile.length < 3){
                return dispatch(raiseToast({severity:'error', detail: `Please upload 3 quotations for Fixed Asset expenses to proceed.`, life: 3000}))
            }
            else if(relatedApproval.config?.minimumFilesToBeUploaded && displayApproval.uploadFile.length < relatedApproval.config?.minimumFilesToBeUploaded){
                return dispatch(raiseToast({severity:'error', detail: `Minimum ${relatedApproval.config?.minimumFilesToBeUploaded} files required. Please upload.`, life: 3000}))
            }
        }

        let remarks = displayApproval.remarks
        let relatedTDSSection = tdsSections.find(eachTDSSection => eachTDSSection.tdsSectionId === sellerPO.tdsSectionId)

        if(displayApproval.approvalTypeId === 21 && relatedTDSSection){
            let tdsAmount = 0
            if(sellerPO.tdsValue){
                tdsAmount = parseFloat(sellerPO.totalItemAmountBeforeTax) * sellerPO.tdsValue / 100
            }
            remarks += `, TDS Section: ${relatedTDSSection.tdsSectionName} (${sellerPO.tdsValue}), TDS Amount: ${tdsAmount}`
        }

        setRaiseReqLoading(true)

        const newApprovalReq = {
            ...displayApproval, 
            approvalInstanceId: undefined, 
            statusId: 12, 
            docNo: sellerPO.docNo, 
            parentDocNo: sellerReq.docNo, 
            buyerCompanyId: null, 
            sellerCompanyId: sellerPO.companyId, 
            docTypeId: 15, 
            docId: sellerPO.sellerPOId, 
            branchId: sellerPO.pmBranchId, 
            createdBy: userDetails.userId,
            uploadFile: displayApproval.uploadFile,
            remarks,
            processedBy: null,
            processedAt: null,
            processedRemarks: null
        }

        if (window.confirm("Are you sure to raise the Approval Request..?")){
            const newApprovalInstanceRes = await insertApprovalInstances({ requestedApprovals: [newApprovalReq] })
            if(newApprovalInstanceRes.failure){
                setRaiseReqLoading(false)
                return dispatch(raiseToast({severity:'error', detail: newApprovalInstanceRes.data.error, life: 3000}))
            }
            handleApprovalRequest({...newApprovalInstanceRes.data[0], srNo: displayApproval.srNo, requestStatus: "REQUESTED"})
        }
        setRaiseReqLoading(false)
    }

    const getProfit = (sellerPOItem, buyerPOItem) => {
        const buyerAmountBeforeTax = parseFloat(buyerPOItem.bPOUnitPrice) * parseFloat(sellerPOItem.qty)
        const buyerAmountAfterTax = round(buyerAmountBeforeTax + (parseFloat(buyerPOItem.bPOGSTRate) * buyerAmountBeforeTax * 0.01))

        return buyerAmountAfterTax - round(sellerPOItem.itemAmountWithTax)
    }

    const handleApprovalRemarks = (id, text, prefillText) => {
        handleRemarks(id, text, prefillText)
    }

    const handleApproverChange = (srNo, userId) => {
        const updatedApprovalRequestStatusDetails = approvalRequestStatusDetails.map(eachRequestDetail => {
            if (eachRequestDetail.srNo === srNo) {
                return { ...eachRequestDetail, notifyToUserId: userId }
            }
            return eachRequestDetail
        })

        setApprovalRequestStatusDetails(updatedApprovalRequestStatusDetails)
    }

    const getApprovalBody = (approvalTypeId, products, sellerPOPaymentTerms, companyPaymentTerms, relatedSellerPOApproval) => {
        let lossMakingSellerPOItems = []
        switch (approvalTypeId){
            case 9 :
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">DOC NO</th>
                                <th className="custom-th">COMPANY NAME</th>
                                <th className="custom-th">REQUESTED PAYMENT TERMS</th>
                                <th className="custom-th">COMPANY PAYMENT TERMS</th>
                                <th className="custom-th">GRAND TOTAL</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                <td className="custom-td">{sellerPO.docNo}</td>
                                <td className="custom-td">{sellerCompanyDetails.companyName}</td>
                                <td className="custom-td">{sellerPOPaymentTerms}</td>
                                <td className="custom-td">{companyPaymentTerms}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO.totalItemAmountWithTax}</td>
                            </tr>
                        </tbody>
                    </table>
                )
                break
            case 16:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">MATERIAL ID</th>
                                <th className="custom-th">PRODUCT NAME</th>
                                <th className="custom-th">PRODUCT SPECIFICATION</th>
                                <th className="custom-th">AVG UNIT PRICE</th>
                                <th className="custom-th">SELLER UNIT PRICE</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            sellerPOItems?.map(eachSellerPOItem => {
                                const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachSellerPOItem?.materialId)
                                const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqItemId === eachSellerPOItem?.buyerReqItemId && eachBuyerQuoteItem?.statusId === 1 && eachBuyerQuoteItem?.totReqQty > 0)
                                let totalSellerQuotPrice = 0
                                relatedBuyerQuoteItems?.map(eachBuyerQuoteItem => {
                                    totalSellerQuotPrice += parseFloat(eachBuyerQuoteItem?.bQuotSellerPrice)
                                })
                                let avgSellerQuotPrice = round(totalSellerQuotPrice / (relatedBuyerQuoteItems?.length))
                                
                                return (
                                    <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                        <td className="custom-td">{eachSellerPOItem?.materialId}</td>
                                        <td className="custom-td">{relatedMaterial?.productName}</td>
                                        <td className="custom-td">{relatedMaterial?.productSpecification}</td>
                                        <td className="custom-td">{currencyShortName}.{avgSellerQuotPrice}</td>
                                        <td className="custom-td">{currencyShortName}.{eachSellerPOItem?.unitPrice}</td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                )
                break
            case 17:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                    <thead >
                        <tr className="custom-table-tr">
                            <th className="custom-th">PRODUCTS</th>
                            <th className="custom-th">PRICE BEFORE TAX</th>
                            <th className="custom-th">TOTAL AMOUNT WITH TAX</th>
                            <th className="custom-th">GRAND TOTAL</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                            <td className="custom-td">{products.join(', ')}</td>
                            <td className="custom-td">{sellerPO?.totalItemAmountBeforeTax}</td>
                            <td className="custom-td">{currencyShortName}.{sellerPO?.totalItemAmountWithTax}</td>
                            <td className="custom-td">{currencyShortName}.{sellerPO.totalPOAmount}</td>
                        </tr>
                    </tbody>
                </table>
                )
                break
            case 20:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">PRICE BEFORE TAX</th>
                                <th className="custom-th">TOTAL AMOUNT WITH TAX</th>
                                <th className="custom-th">GRAND TOTAL</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                <td className="custom-td">{products.join(', ')}</td>
                                <td className="custom-td">{sellerPO?.totalItemAmountBeforeTax}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO?.totalItemAmountWithTax}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO.totalPOAmount}</td>
                            </tr>
                        </tbody>
                    </table>
                )
                break
            case 21:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">PRICE BEFORE TAX</th>
                                <th className="custom-th">TOTAL AMOUNT WITH TAX</th>
                                <th className="custom-th">GRAND TOTAL</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                <td className="custom-td">{products.join(', ')}</td>
                                <td className="custom-td">{sellerPO?.totalItemAmountBeforeTax}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO?.totalItemAmountWithTax}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO.totalPOAmount}</td>
                            </tr>
                        </tbody>
                    </table>
                )
                break
            case 33: //Loss
                lossMakingSellerPOItems = sellerPOItems.filter(eachSellerPOItem => {
                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                    const amount = getProfit(eachSellerPOItem, relatedBuyerPOItem)
                    if (amount < 0) {
                        return true
                    }
                    return false
                })

                if (lossMakingSellerPOItems.length === 0) return null

                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">S.No</th>
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">SPECIFICATION</th>
                                <th className="custom-th">BUYER UNIT PRICE</th>
                                <th className="custom-th">QUANTITY</th>
                                <th className="custom-th">TOTAL PRICE</th>
                                <th className="custom-th">LOSS</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                lossMakingSellerPOItems.map((eachSellerPOItem, index) => {
                                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                                    const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerPOItem.materialId)

                                    const lossAmount = getProfit(eachSellerPOItem, relatedBuyerPOItem)
                                    const buyerAmountBeforeTax = parseFloat(relatedBuyerPOItem.bPOUnitPrice) * parseFloat(eachSellerPOItem.qty)
                                    const buyerAmountAfterTax = round(buyerAmountBeforeTax + (parseFloat(relatedBuyerPOItem.bPOGSTRate) * buyerAmountBeforeTax * 0.01))

                                    return (
                                        <tr key={eachSellerPOItem.sellerPOItemId} className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="custom-td">{index + 1}</td>
                                            <td className="custom-td">{relatedMaterialDetails.productName}</td>
                                            <td className="custom-td">{relatedMaterialDetails.productSpecification}</td>
                                            <td className="custom-td">{numberConversion(relatedBuyerPOItem.bPOUnitPrice)}</td>
                                            <td className="custom-td">{eachSellerPOItem.qty}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(buyerAmountAfterTax)}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(lossAmount)}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
                break
            case 32: //brand
                const { brand_id } = getApprovalParams(relatedSellerPOApproval)
                const brandMaterialDetails = materialDetails.filter(eachMaterial => eachMaterial.brandId === brand_id)
                const relatedBrandMaterialIds = brandMaterialDetails.map(eachMaterial => eachMaterial.materialId)
                const brandRelatedSellerPOItems = sellerPOItems.filter(eachSellerPOItem => relatedBrandMaterialIds.includes(eachSellerPOItem.materialId))

                if (brandRelatedSellerPOItems.length === 0) return null

                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">S.No</th>
                                <th className="custom-th">MATERIAL ID</th>
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">SPECIFICATION</th>
                                <th className="custom-th">SELLER UNIT PRICE</th>
                                <th className="custom-th">QUANTITY</th>
                                <th className="custom-th">TOTAL PRICE</th>
                                <th className="custom-th">PROFIT</th>
                                {/* <th className="custom-th">PROFIT PERCENTAGE</th> */}
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                brandRelatedSellerPOItems.map((eachSellerPOItem, index) => {
                                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                                    const profitAmount = getProfit(eachSellerPOItem, relatedBuyerPOItem)

                                    const relatedMaterialBrandDetails = brandMaterialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerPOItem.materialId)

                                    return (
                                        <tr key={eachSellerPOItem.buyerReqItemId} className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="custom-td">{index + 1}</td>
                                            <td className="custom-td">{relatedMaterialBrandDetails.materialId}</td>
                                            <td className="custom-td">{relatedMaterialBrandDetails.productName}</td>
                                            <td className="custom-td">{relatedMaterialBrandDetails.productSpecification}</td>
                                            <td className="custom-td">{numberConversion(eachSellerPOItem.unitPrice)}</td>
                                            <td className="custom-td">{eachSellerPOItem.qty}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(eachSellerPOItem.itemAmountWithTax)}</td>
                                            <th className="custom-th">{currencyShortName}.{numberConversion(profitAmount)}</th>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
                break
            case 31: //Category
                const { category_ids } = getApprovalParams(relatedSellerPOApproval)
                const categoryMaterialDetails = materialDetails.filter(eachMaterial => category_ids.includes(eachMaterial.categoryId))
                const relatedCategoryMaterialIds = categoryMaterialDetails.map(eachMaterial => eachMaterial.materialId)
                const categoryRelatedSellerPOItems = sellerPOItems.filter(eachSellerPOItem => relatedCategoryMaterialIds.includes(eachSellerPOItem.materialId))

                if (categoryRelatedSellerPOItems.length === 0) return null

                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">S.No</th>
                                <th className="custom-th">MATERIAL ID</th>
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">SPECIFICATION</th>
                                <th className="custom-th">SELLER UNIT PRICE</th>
                                <th className="custom-th">BUYER UNIT PRICE</th>
                                <th className="custom-th">QUANTITY</th>
                                <th className="custom-th">TOTAL PRICE</th>
                                <th className="custom-th">PROFIT</th>
                                <th className="custom-th">PROFIT PERCENTAGE</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                categoryRelatedSellerPOItems.map((eachSellerPOItem, index) => {
                                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                                    const profitAmount = getProfit(eachSellerPOItem, relatedBuyerPOItem)

                                    const relatedMaterialCategoryDetails = categoryMaterialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerPOItem.materialId)

                                    const profitPercentage = round((profitAmount / (eachSellerPOItem.unitPrice * parseFloat(eachSellerPOItem.qty))) * 100, 2)

                                    return (
                                        <tr key={eachSellerPOItem.buyerReqItemId} className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="custom-td">{index + 1}</td>
                                            <td className="custom-td">{relatedMaterialCategoryDetails.materialId}</td>
                                            <td className="custom-td">{relatedMaterialCategoryDetails.productName}</td>
                                            <td className="custom-td">{relatedMaterialCategoryDetails.productSpecification}</td>
                                            <td className="custom-td">{numberConversion(eachSellerPOItem.unitPrice)}</td>
                                            <td className="custom-td">{numberConversion(relatedBuyerPOItem.bPOUnitPrice)}</td>
                                            <td className="custom-td">{eachSellerPOItem.qty}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(relatedBuyerPOItem.bPOItemAmountWithTax)}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(profitAmount)}</td>
                                            <td className="custom-td">{profitPercentage}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
                break
            case 37:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">MATERIAL ID</th>
                                <th className="custom-th">PRODUCT NAME</th>
                                <th className="custom-th">PRODUCT SPECIFICATION</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            sellerPOItems?.map(eachSellerPOItem => {
                                const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachSellerPOItem?.materialId)
                                const relatedMandatoryMaterialUseStock = materialMandatoryUseFromStock.find(eachMaterialMandatory => eachMaterialMandatory.materialId === relatedMaterial.materialId)

                                if (relatedMandatoryMaterialUseStock){
                                    return (
                                        <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="custom-td">{eachSellerPOItem.materialId}</td>
                                            <td className="custom-td">{relatedMaterial.productName}</td>
                                            <td className="custom-td">{relatedMaterial.productSpecification}</td>
                                        </tr>
                                    )
                                }
                            })
                        }
                        </tbody>
                    </table>
                )
                break
            case 41:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">PRICE BEFORE TAX</th>
                                <th className="custom-th">TOTAL AMOUNT WITH TAX</th>
                                <th className="custom-th">GRAND TOTAL</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                <td className="custom-td">{products.join(', ')}</td>
                                <td className="custom-td">{sellerPO?.totalItemAmountBeforeTax}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO?.totalItemAmountWithTax}</td>
                                <td className="custom-td">{currencyShortName}.{sellerPO.totalPOAmount}</td>
                            </tr>
                        </tbody>
                    </table>
                )
                break
            case 42:
                lossMakingSellerPOItems = sellerPOItems.filter(eachSellerPOItem => {
                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                    const amount = getProfit(eachSellerPOItem, relatedBuyerPOItem)
                    if (amount < 0) {
                        return true
                    }
                    return false
                })

                if (lossMakingSellerPOItems.length === 0) return null

                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">S.No</th>
                                <th className="custom-th">PRODUCTS</th>
                                <th className="custom-th">SPECIFICATION</th>
                                <th className="custom-th">BUYER UNIT PRICE</th>
                                <th className="custom-th">QUANTITY</th>
                                <th className="custom-th">TOTAL PRICE</th>
                                <th className="custom-th">LOSS</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                            {
                                lossMakingSellerPOItems.map((eachSellerPOItem, index) => {
                                    const relatedBuyerPOItem = buyerPOItems.find(eachBuyerPOItem => eachBuyerPOItem.buyerPOItemId === eachSellerPOItem.buyerPOItemId)
                                    const relatedMaterialDetails = materialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerPOItem.materialId)

                                    const lossAmount = getProfit(eachSellerPOItem, relatedBuyerPOItem)
                                    const buyerAmountBeforeTax = parseFloat(relatedBuyerPOItem.bPOUnitPrice) * parseFloat(eachSellerPOItem.qty)
                                    const buyerAmountAfterTax = round(buyerAmountBeforeTax + (parseFloat(relatedBuyerPOItem.bPOGSTRate) * buyerAmountBeforeTax * 0.01))

                                    return (
                                        <tr key={eachSellerPOItem.sellerPOItemId} className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="custom-td">{index + 1}</td>
                                            <td className="custom-td">{relatedMaterialDetails.productName}</td>
                                            <td className="custom-td">{relatedMaterialDetails.productSpecification}</td>
                                            <td className="custom-td">{numberConversion(relatedBuyerPOItem.bPOUnitPrice)}</td>
                                            <td className="custom-td">{eachSellerPOItem.qty}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(buyerAmountAfterTax)}</td>
                                            <td className="custom-td">{currencyShortName}.{numberConversion(lossAmount)}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                )
                break
            case 44:
                return (
                    <table className="custom-table" style={{ width: "100%" }}>
                        <thead >
                            <tr className="custom-table-tr">
                                <th className="custom-th">MATERIAL ID</th>
                                <th className="custom-th">PRODUCT NAME</th>
                                <th className="custom-th">PRODUCT SPECIFICATION</th>
                                <th className="custom-th">CERTIFICATE MISSING BRAND</th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                        {
                            sellerPOItems.map(eachSellerPOItem => {
                                const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial?.materialId === eachSellerPOItem?.materialId)
                                const relatedMaterialBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === relatedMaterial.brandId)
                                let isBrandCertificateMissing = false
                                if (relatedMaterialBrand.config?.certificateProofMandatory){
                                    const relatedCompanyBrandCertificate = companyCertificates.find(eachCompanyCertificate => eachCompanyCertificate.companyId === sellerPO.companyId && eachCompanyCertificate.entityId === relatedMaterialBrand.brandId && eachCompanyCertificate.statusId === 1 && moment(new Date()).format("YYYY-MM-DD") <= eachCompanyCertificate.expiryDate)
                                    if (!relatedCompanyBrandCertificate){
                                        isBrandCertificateMissing = true
                                    }
                                }
                                
                                if (isBrandCertificateMissing){
                                    return (
                                        <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                            <td className="custom-td">{eachSellerPOItem.materialId}</td>
                                            <td className="custom-td">{relatedMaterial.productName}</td>
                                            <td className="custom-td">{relatedMaterial.productSpecification}</td>
                                            <td className="custom-td">{relatedMaterialBrand.brandName}</td>
                                        </tr>
                                    )
                                }
                            })
                        }
                        </tbody>
                    </table>
                )
                break
            default:
                return null
        }

    }

    const renderApprovals = (sellerPO, approvalInstances, sellerPOApprovals, approvalRequestStatusDetails) => {
        const pmCompanyUsers = userDetails?.PMCompanyDetails?.companyUsers ? userDetails?.PMCompanyDetails?.companyUsers : []
        const pmCompanyRoles = userDetails?.PMCompanyDetails?.companyRoles ? userDetails?.PMCompanyDetails?.companyRoles : []
        const pmBranches = userDetails?.PMCompanyDetails?.companyBranches ? userDetails?.PMCompanyDetails?.companyBranches : []

        const updatedApprovalInstances = approvalInstances.map(eachApprovalInstance => {
            const relatedApproval = sellerPOApprovals.find(eachSellerPOApproval => eachSellerPOApproval.approvalId === eachApprovalInstance.approvalId)
            eachApprovalInstance.approvalTypeId = relatedApproval.approvalTypeId
            return eachApprovalInstance
        })

        return approvalRequestStatusDetails.map((eachRequestDetail, index) => {
            const relatedSellerPOApproval = sellerPOApprovals.find(eachSellerPOApproval => eachSellerPOApproval.approvalId === eachRequestDetail.approvalId)
            const relatedApprovalType = approvalTypes.find(eachApprovalType => eachApprovalType.approvalTypeId === relatedSellerPOApproval.approvalTypeId)

            let approvedOrRejectedBy = ""
            if(["REJECTED", "APPROVED"].includes(eachRequestDetail.requestStatus)){
                approvedOrRejectedBy = pmCompanyUsers.find(eachUser => eachUser.userId === eachRequestDetail.processedBy)
            }

            let createdBy = eachRequestDetail.createdBy ? eachRequestDetail.createdBy : userDetails?.userId
            const primaryApprover = getApproverDetails(relatedSellerPOApproval, sellerPO.pmBranchId, createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)
            let relatedHistoryRequests = updatedApprovalInstances.filter(eachReq => eachReq.approvalId === relatedSellerPOApproval.approvalId && eachReq.approvalInstanceId && eachReq.approvalInstanceId !== eachRequestDetail.approvalInstanceId)
            
            let products = []
            sellerPOItems.map(eachSellerPOItem => {
                materialDetails.forEach(eachMaterial => {
                    if (eachSellerPOItem.materialId === eachMaterial.materialId) {
                        products.push(eachMaterial.productName)
                    }
                })
            })

            let sellerPOPaymentTerms = getPaymentTermsString(sellerPO.paymentTerms, companyCreditPeriods)
            sellerPOPaymentTerms = sellerPOPaymentTerms.paymentTermsString

            let companyPaymentTerms = getPaymentTermsString(sellerCompanyDetails.paymentTerms, companyCreditPeriods)
            companyPaymentTerms = companyPaymentTerms.paymentTermsString

            let approvalBody = getApprovalBody(relatedSellerPOApproval.approvalTypeId, products, sellerPOPaymentTerms, companyPaymentTerms, relatedSellerPOApproval)

            return(
                <CommonApprovalDisplay
                    approvalBody={approvalBody}
                    index={index}
                    approvalType={relatedApprovalType}
                    approval={relatedSellerPOApproval}
                    isDoc={isDoc}
                    handleRaiseReq={handleRaiseReq}
                    handleApprovalRemarks={handleApprovalRemarks}
                    handleApproverChange={handleApproverChange}
                    primaryApprover={primaryApprover}
                    eachRequestDetail={eachRequestDetail}
                    approvalRequestStatusDetails={approvalRequestStatusDetails}
                    setApprovalRequestStatusDetails={setApprovalRequestStatusDetails}
                    historyRequests={relatedHistoryRequests}
                    approvedOrRejectedBy={approvedOrRejectedBy}
                />
            )
        })
    }

    return(
        <div className="approval-modal">
            <Loading visible={raiseReqLoading} />
            {renderApprovals(sellerPO, approvalInstances, sellerPOApprovals, approvalRequestStatusDetails)}
        </div>
    )   
}

export default NewApprovalDisplay